import BaseButton from 'core/buttons/base-button';
import PropTypes from 'prop-types';
import styles from 'styles/LeadForm.module.scss';
import TextInput from 'core/text-input';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

const PatentEmailContent = ({ onSubmit, showLoading }) => {
    const [patent, setPatent] = useState('');
    const [email, setEmail] = useState('');
    const t = useTranslations('lead-form');

    const handler = () => {
        onSubmit({ patent, email });
    };

    return (
        <div className={styles.patent_email_form}>
            <TextInput
                fieldName="patent"
                placeholder={t('fields.patent-lbl')}
                setValue={setPatent}
                value={patent}
            />
            <TextInput
                fieldName="email"
                placeholder={t('fields.email-lbl')}
                setValue={setEmail}
                value={email}
            />
            <BaseButton
                label={t('buttons.submit-lbl')}
                divClass={styles.form_button_wrapper}
                buttonClass={styles.form_button}
                onClick={handler}
                parentLoading={showLoading}
            />
        </div>
    );
};

PatentEmailContent.propTypes = {
    onSubmit: PropTypes.func,
    showLoading: PropTypes.bool
};

export default PatentEmailContent;
